import {Component, Input} from '@angular/core';
import {TextInputComponent} from '../text-input';

@Component({
    selector: 'app-autocomplete-text-input',
    templateUrl: './autocomplete-text-input.component.html',
    styleUrls: ['./autocomplete-text-input.component.less'],
})
export class AutocompleteTextInputComponent extends TextInputComponent {
    @Input() suggestions: string[];
}
